import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AboutPage from './pages/aboutpage';
import SignInPage from './pages/SignInPage';
import CompetitionsPage from './pages/CompetitionsPage';
import CompetitionDetailsPage from './pages/CompetitionDetailsPage';
import SettingsPage from './pages/SettingsPage';
import MyAccountPage from './pages/MyAccountPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={HomePage} />
        <Route path="/home" component={HomePage} />
        <Route path="/about" component={AboutPage} />
        <Route path="/signin" component={SignInPage} />
        <Route path="/competitions/:id" component={CompetitionDetailsPage} />
        <Route path="/competitions" component={CompetitionsPage} />
        <Route path="/settings" component={SettingsPage} />
        <Route path="/my-account" component={MyAccountPage} />
        {/* Dev email listing removed from main branch */}
        <Route component={NotFoundPage} />
      </Switch>
    </Router>
  );
}

export default App;